import React, { useState } from "react";
import { Flex } from "rebass/styled-components";
import { Tag } from "../../../Components/Tag";

import { useUser } from "../../../Hooks/useUser";
import { ESupportedGames } from "../../../@types";
import { ResponsiveValue } from "styled-system";
import { useHistory } from "react-router-dom";
import {
  StudioCards,
  TStudioCardTag,
} from "../../../Components/Clip/Components/StudioCardList";
import { capitalize } from "../../../Utilities/CapitalizeString";
import { analytics } from "MVVM/Analytics";

type TTagsProps = {
  tags: any;
  game: ESupportedGames;
  mt: ResponsiveValue<string | number | symbol>;
  isFeed: boolean;
  cards: TStudioCardTag[];
};

function Tags({ tags, game, mt, isFeed, cards }: TTagsProps) {
  const { allstarUser } = useUser();
  const history = useHistory();
  const [displayedTags] = useState(() => {
    if (!isFeed) return tags;
    switch (game) {
      case ESupportedGames.CSGO:
        return tags.filter((tag: any): any => {
          return (
            ["CS_Round", "CS_Game Mode", "CS_Game Type"].indexOf(tag.key) === -1
          );
        });
      case ESupportedGames.DOTA2:
        return tags.filter((tag: any): any => {
          return (
            [
              "DOTA_Game Mode",
              "DOTA_Role",
              "DOTA_Damage Taken",
              "DOTA_Hero Damage",
              "DOTA_Objective Damage",
              "DOTA_Healing",
              "DOTA_Healing Received",
              "DOTA_Gold Lost",
              "DOTA_XP Gained",
            ].indexOf(tag.key) === -1
          );
        });
      case ESupportedGames.FORTNITE:
        return tags.filter((tag: any): any => {
          return (
            [
              "FORTNITE_Game Mode",
              "FORTNITE_Cosmetic",
              "FORTNITE_Game Phase",
            ].indexOf(tag.key) === -1
          );
        });
      case ESupportedGames.LOL:
        return tags.filter((tag: any): any => {
          return (
            [
              "LEAGUE_Game Mode",
              "LEAGUE_True Damage Dealt",
              "LEAGUE_Class",
              "LEAGUE_Position",
              "LEAGUE_Solo Kill Count",
            ].indexOf(tag.key) === -1
          );
        });
      default:
        return tags;
    }
  });
  const ON_CLICKS: any = {
    [ESupportedGames.CSGO]: function csgoTagClick(tag: any) {
      const value = tag.currentTarget.id.split(":")[1];
      const key = tag.currentTarget.id.split(":")[0];
      let filterString = "";

      if (key === "Kill Count") {
        filterString = `["Kills:${value}"]`;
      } else if (key === "Headshots") {
        filterString = `["HS:${value}"]`;
      } else {
        filterString = `["${value !== "false" ? value : key}"]`;
      }

      analytics.track("Filter/Sort Action", {
        filter: filterString,
        interface: "tag",
        game: "csgo",
        target: "gallery",
      });

      history.push(`clips?filter=${filterString}&game=${ESupportedGames.CSGO}`);
    },
    [ESupportedGames.DOTA2]: function dotaTagClick(tag: any) {
      const value = tag.currentTarget.id.split(":")[1];
      const key = tag.currentTarget.id.split(":")[0];
      let filterString = "";

      if (key === "Kill Count") {
        filterString = `["Kills:${value}"]`;
      } else if (key === "Assists") {
        filterString = `["Assists:${value}"]`;
      } else {
        filterString = `["${value !== "false" ? value : key}"]`;
      }

      analytics.track("Filter/Sort Action", {
        filter: filterString,
        interface: "tag",
        game: "dota",
        target: "gallery",
      });

      history.push(
        `clips?filter=${filterString}&game=${ESupportedGames.DOTA2}`,
      );
    },
    [ESupportedGames.LOL]: function leagueTagClick(tag: any) {
      const value = tag.currentTarget.id.split(":")[1];
      const key = tag.currentTarget.id.split(":")[0];
      const filterString = `["${value !== "false" ? value : key}"]`;

      analytics.track("Filter/Sort Action", {
        filter: filterString,
        interface: "tag",
        game: "lol",
        target: "gallery",
      });

      history.push(`clips?filter=${filterString}&game=${ESupportedGames.LOL}`);
    },
    [ESupportedGames.FORTNITE]: function fortniteTagClick(tag: any) {
      const value = tag.currentTarget.id.split(":")[1];
      const key = tag.currentTarget.id.split(":")[0];
      const filterString = `["${value !== "false" ? value : key}"]`;

      analytics.track("Filter/Sort Action", {
        filter: filterString,
        interface: "tag",
        game: "fortnite",
        target: "gallery",
      });

      history.push(
        `clips?filter=${filterString}&game=${ESupportedGames.FORTNITE}`,
      );
    },
  };

  return (
    <Flex flexWrap="wrap" mt={mt} justifyContent="start">
      <StudioCards cards={cards} />
      {displayedTags.map((tag: any, i: any) => {
        //this is a bunch of logic to hide tags we dont want to display for various reasons and also to display some tags only to admins
        if (tag.displayType === "none") {
          return false;
        }
        if (
          tag.key === "COTD" ||
          tag.key === "CSGO" ||
          tag.key === "HOMEPAGE"
        ) {
          return false;
        }
        let displayKey = tag.key.split("_").pop();
        let displayValue = tag.value;
        if (tag.displayType === "none") return false;

        if (tag.displayType === "boolean") {
          displayValue = false;
          displayKey = tag.value;
        }
        if (typeof tag !== "object") return false;
        if (displayKey.includes("Contains Headshots")) return false;
        if (displayKey.includes("All Headshots")) return false;
        if (displayKey === "Allstar Studio" && !allstarUser.isAdmin) {
          return false;
        } else if (displayKey === "Allstar Studio") {
          return false;
          // displayKey = "*Allstar Studio";
        }

        displayValue = displayValue ? capitalize(displayValue) : displayValue;

        return (
          <Tag
            key={`tag-${tag._id}`}
            cursor="pointer"
            id={`${displayKey}:${displayValue}`}
            title={displayKey}
            value={displayValue}
            onClick={ON_CLICKS[game]}
          />
        );
      })}
    </Flex>
  );
}

export { Tags };
